<app-modal-wrapper [ngStyle]="{'height':'605px' , 'width':'560px'}"  (cancel)="onCancel($event)" [options]="options">
  <div class="search-save-poup-container card-body">
    <div class="form-group col-12">
      <kendo-grid [data]="files" [selectable]="true" [kendoGridSelectBy]="'fileId'" class="k-header files" style="height:450px; width:540px">
        <kendo-grid-column field="selected" title="Selected" [width]="100">

          <ng-template kendoGridHeaderTemplate let-dataItem >
            <input type="checkbox" class="k-checkbox" (click)="clkboxAll($event)" />
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox"  [ngClass]="{'file-checkbox':dataItem.videoLink==''}" class="k-checkbox" [disabled]="dataItem.videoLink!=''" (change)="clkbox(dataItem.fileId)" />
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="fileName" title="File Name" [width]="200"></kendo-grid-column>
        <kendo-grid-column title="View" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a [href]='dataItem.videoLink' target="_blank" *ngIf="dataItem.videoLink!=''">View</a>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
      <div class="row" style="justify-content: flex-end;">
        <div class="btn-group d-flex justify-flex-end" style="justify-content: flex-end;" role="group" aria-label="Basic example">
          <button type="button" class="download-btn pull-left" (click)="download()">Download</button>
        </div>
        
        </div>
      </div>
  </div>
</app-modal-wrapper>
<div id="taxonomy-download" style="display: none; z-index: 1000; ">
  <div class="" data-fa-i2svg="">
    <svg class="svg-inline--fa fa-spinner fa-w-16 fa-spin" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
  </div>
</div>

